import { Box, Grid } from '@mui/material';

import Typography from '@components/Typography';
import { FAQSectionWrapper } from './style';
import { FAQItem } from './FAQItem';

import type { FAQItemData } from '@components/FAQSection';
import type { FC } from 'react';

export type FAQSectionProps = {
  header?: string;
  items?: FAQItemData[];
};

export const FAQSection: FC<FAQSectionProps> = ({ header, items }) => {
  if (!items || items.length === 0) return null;

  return (
    <FAQSectionWrapper>
      <Grid xs={12} justifyContent="center" mt={6}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="stretch"
          flexWrap="wrap"
          width="100%"
        >
          {header && (
            <Typography type="H2" className="header-text">
              {header}
            </Typography>
          )}
          <Box width={{ xs: '100%' }}>
            {items?.map((item, index) => (
              <FAQItem key={index} title={item.title} content={item.content} />
            ))}
          </Box>
        </Box>
      </Grid>
    </FAQSectionWrapper>
  );
};
